/**
 * The line under the Decide title that says the rail is free to use while a draft is open (owner notes 22 Oct, item 8).
 * Round 1 always shows it; later rounds show it until it is dismissed, remembered per browser.
 */
import { useState } from "react";

const KEY = "bsim.decide.navHint.dismissed";
const read = (): boolean => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };

export const NAV_HINT = "You can move between Bank, Decide and Outlook at any time; your draft is kept.";

export function NavHint({ roundNo }: { readonly roundNo: number }) {
  const [gone, setGone] = useState(read);
  if (roundNo > 1 && gone) return null;
  const dismiss = (): void => { try { localStorage.setItem(KEY, "1"); } catch { /* storage unavailable: it shows again next time */ } setGone(true); };
  const x = roundNo > 1 ? <button type="button" className="gx-x gx-decide-navhint-x" onClick={dismiss} aria-label="Hide this tip about moving between pages">{"\u00D7"}</button> : null;
  return (
    <p className="gx-small gx-muted gx-decide-navhint gx-decide-notice" data-testid="decide.navhint">
      <span className="gx-decide-notice-t">{NAV_HINT}</span>
      {x}
    </p>
  );
}
